import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_BASE, setToken } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { SEO } from "@/components/shared/SEO";

export const AuthCallback: React.FC = () => {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");

    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await axios.post(
          `${API_BASE}/auth/google/session`,
          {},
          {
            headers: { "X-Session-ID": sessionId },
            withCredentials: true,
          },
        );
        setToken(data.token);
        await refresh();
        toast.success(`Welcome, ${data.user.name}`);
        nav("/dashboard", { replace: true });
      } catch (err: any) {
        toast.error("Google sign-in failed. Please try again.");
        nav("/login", { replace: true });
      }
    })();
  }, [nav, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--sg-bg)]">
      <SEO title="Signing you in…" noindex path="/auth/callback" />
      <div className="text-center">
        <h1 className="sr-only">Signing you in to SociBaba</h1>
        <div className="sg-skeleton h-4 w-32 mx-auto mb-2" />
        <div className="text-sm text-[color:var(--sg-muted)] mt-4">
          Finishing sign-in…
        </div>
      </div>
    </div>
  );
};
